/* Custom JS for PlayGoSports (Focal theme). */
/* build 2026-09-28-r3 | reviews submit-fix + 1-click scroll-to-reviews (instant) + variant-rehydrate */

/* -----------------------------------------------------------------------------
 * Klaviyo back-in-stock form (<pgs-back-in-stock>, snippets/pgs-back-in-stock.liquid).
 *
 * The markup is server-rendered inside <product-payment-container>, which Focal
 * swaps out on every variant change, so a custom element re-initializes itself
 * for each new copy. It sits inside the product <form>, so it uses a plain button
 * (no nested form) and catches Enter in the email field so the browser doesn't
 * try to submit the add-to-cart form. Subscribes via Klaviyo's Client API with
 * the public site key; Klaviyo's Back in Stock flow sends the restock email.
 * --------------------------------------------------------------------------- */
(function () {
  if (window.customElements.get('pgs-back-in-stock')) return;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  class PgsBackInStock extends HTMLElement {}

  PgsBackInStock.prototype.connectedCallback = function () {
    if (this._ready) return;
    this._ready = true;
    this.email = this.querySelector('.pgs-bis__email');
    this.submitButton = this.querySelector('.pgs-bis__submit');
    this.message = this.querySelector('.pgs-bis__message');
    if (!this.email || !this.submitButton || !this.message) return;

    var self = this;
    this.submitButton.addEventListener('click', function () { self.submit(); });
    this.email.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); self.submit(); }
    });
    this.email.addEventListener('input', function () {
      if (self.email.getAttribute('aria-invalid') === 'true') self.setMessage('', false);
    });
  };

  PgsBackInStock.prototype.setMessage = function (text, isError) {
    this.message.textContent = text;
    this.message.classList.toggle('is-error', !!isError);
    if (isError) this.email.setAttribute('aria-invalid', 'true');
    else this.email.removeAttribute('aria-invalid');
  };

  PgsBackInStock.prototype.submit = function () {
    if (this._busy) return;
    var value = this.email.value.trim();
    if (!EMAIL_RE.test(value)) {
      this.setMessage(this.message.getAttribute('data-invalid'), true);
      this.email.focus();
      return;
    }

    var self = this;
    this._busy = true;
    this.submitButton.setAttribute('aria-disabled', 'true');
    this.setMessage('', false);

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + encodeURIComponent(this.getAttribute('data-company-id')), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: value } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + this.getAttribute('data-variant-id') } }
          }
        }
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo back-in-stock: HTTP ' + res.status);
      // Success: the email field and button go away, so move focus to the confirmation instead of losing it.
      self.querySelector('.pgs-bis__fields').hidden = true;
      self.querySelector('.pgs-bis__intro').hidden = true;
      self.setMessage(self.message.getAttribute('data-success'), false);
      self.message.focus();
    }).catch(function (err) {
      console.error(err);
      self.setMessage(self.message.getAttribute('data-error'), true);
      self.email.focus();
    }).then(function () {
      self._busy = false;
      self.submitButton.removeAttribute('aria-disabled');
    });
  };

  window.customElements.define('pgs-back-in-stock', PgsBackInStock);
})();

/* -----------------------------------------------------------------------------
 * Quick View image carousel: give the quick-buy drawer/popover the same swipe +
 * dots behavior as the PDP mobile gallery, on desktop AND mobile. The markup
 * (.quick-buy-product__gallery > .quick-buy-product__slide) is a CSS scroll-snap
 * strip; this builds a dots-nav under it, syncs the active dot on scroll, and
 * scrolls to a slide when a dot is clicked. Runs for galleries injected by the
 * quick-buy fetch and rebuilt on Focal's variant re-render (MutationObserver).
 * --------------------------------------------------------------------------- */
(function () {
  function initGallery(g) {
    if (!g || g.dataset.qbGallery) return;
    var slides = g.querySelectorAll('.quick-buy-product__slide');
    if (slides.length < 2) { g.dataset.qbGallery = '1'; return; }
    g.dataset.qbGallery = '1';

    var nav = document.createElement('div');
    nav.className = 'quick-buy-gallery-dots';

    function goTo(i) { g.scrollTo({ left: i * g.clientWidth, behavior: 'smooth' }); }

    for (var i = 0; i < slides.length; i++) {
      (function (idx) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'quick-buy-gallery-dot' + (idx === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to image ' + (idx + 1));
        dot.addEventListener('click', function () { goTo(idx); });
        nav.appendChild(dot);
      })(i);
    }
    g.insertAdjacentElement('afterend', nav);

    var dots = nav.children;
    var raf;
    g.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var idx = Math.round(g.scrollLeft / g.clientWidth);
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === idx);
        }
      });
    }, { passive: true });
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches('.quick-buy-product__gallery')) initGallery(node);
    if (node.querySelectorAll) {
      var gs = node.querySelectorAll('.quick-buy-product__gallery');
      for (var i = 0; i < gs.length; i++) initGallery(gs[i]);
    }
  }

  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) scan(added[j]);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  var existing = document.querySelectorAll('.quick-buy-product__gallery');
  for (var k = 0; k < existing.length; k++) initGallery(existing[k]);
})();

/* -----------------------------------------------------------------------------
 * Free-shipping message: keep the "$X away from free shipping" countdown in sync
 * with the live cart (native replacement for the Shipsell app). Whenever the
 * mini-cart changes (add / remove / qty), re-fetch /cart.js and update every
 * .pgs-free-ship element (PDP + any open Quick View). Initial state is rendered
 * server-side by snippets/pgs-free-shipping.liquid.
 * --------------------------------------------------------------------------- */
(function () {
  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }

  function apply(total) {
    var els = document.querySelectorAll('.pgs-free-ship');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var threshold = parseInt(el.getAttribute('data-fs-threshold'), 10);
      var textEl = el.querySelector('.pgs-free-ship__text');
      if (!threshold || !textEl) continue;
      if (total >= threshold) {
        textEl.textContent = 'Your order ships free!';
      } else if (total > 0) {
        textEl.textContent = 'You’re ' + fmt(threshold - total) + ' away from FREE shipping';
      } else {
        textEl.textContent = 'Free Shipping on orders $' + Math.round(threshold / 100) + '+';
      }
    }
  }

  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { apply(c.total_price); })
      .catch(function () {});
  }

  function watch() {
    var mc = document.querySelector('mini-cart, .mini-cart');
    if (mc && window.MutationObserver) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(refresh, 150); })
        .observe(mc, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();

/* -----------------------------------------------------------------------------
 * No main-cart page: route every cart-page link to the mini-cart drawer.
 *
 * The header cart icon already opens the drawer (Focal handles clicks on
 * [aria-controls="mini-cart"]). This catches every OTHER link to the cart PAGE —
 * the JS-rendered "View cart" in the Quick View add-to-cart notification, the
 * mini-cart's own fallback link, and any app-injected cart links — and opens the
 * drawer instead of navigating. Only the cart page (/cart, /cart/, localized
 * .../cart) is intercepted; AJAX endpoints (/cart/change, /cart/add, /cart/update)
 * and form posts are left alone. Falls back to normal navigation if the drawer
 * opener is missing.
 * --------------------------------------------------------------------------- */
(function () {
  function openMiniCart() {
    var drawer = document.getElementById('mini-cart');
    if (drawer && drawer.hasAttribute('open')) return true;      // already open
    var opener = document.querySelector('[aria-controls="mini-cart"]');
    if (opener) { opener.click(); return true; }
    return false;
  }

  // If the clicked link lives inside an open Quick View overlay, close it first —
  // otherwise the mini-cart opens hidden behind it and looks like nothing happened.
  function closeQuickBuy(fromEl) {
    var qb = fromEl && fromEl.closest ? fromEl.closest('quick-buy-drawer, quick-buy-popover') : null;
    if (!qb) qb = document.querySelector('quick-buy-drawer[open], quick-buy-popover[open]');
    if (!qb) return false;
    var closeBtn = qb.querySelector('[data-action="close"]');
    if (closeBtn) { closeBtn.click(); } else { qb.removeAttribute('open'); }
    return true;
  }

  function isCartPageLink(a) {
    var raw = a.getAttribute('href') || '';
    if (raw.indexOf('cart') === -1) return false; // fast reject
    var url;
    try { url = new URL(a.href, window.location.origin); } catch (e) { return false; }
    if (url.origin !== window.location.origin) return false; // external
    return /\/cart\/?$/.test(url.pathname); // /cart, /cart/, /xx-yy/cart — not /cart/change etc.
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    if (a.getAttribute('aria-controls') === 'mini-cart') return; // header cart: Focal handles it
    if (a.hasAttribute('data-no-cart-intercept')) return;        // explicit opt-out
    if (!isCartPageLink(a)) return;
    e.preventDefault();
    e.stopPropagation();
    var closed = closeQuickBuy(a);                                // close Quick View if the link is inside one
    setTimeout(function () {
      if (!openMiniCart()) { window.location.href = a.href; }     // graceful fallback
    }, closed ? 260 : 0);
  }, true); // capture phase: beat the link's own navigation and other handlers
})();

/* -----------------------------------------------------------------------------
 * Quick View drawer: show a small "Item added to cart" confirmation next to the
 * close (X) instead of Focal's full-width cart-notification banner (CSS-hidden).
 * Focal still populates its <cart-notification> on add — use that as the signal,
 * inject/show a compact header message, and auto-hide it after a moment.
 * --------------------------------------------------------------------------- */
(function () {
  function showAdded(drawer) {
    var header = drawer.querySelector('.drawer__header');
    if (!header) return;
    var msg = header.querySelector('.qb-added');
    if (!msg) {
      msg = document.createElement('span');
      msg.className = 'qb-added';
      msg.setAttribute('aria-live', 'polite');
      msg.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>Item added to cart';
      header.appendChild(msg);
    }
    requestAnimationFrame(function () { msg.classList.add('is-visible'); });
    clearTimeout(drawer._qbAddedT);
    drawer._qbAddedT = setTimeout(function () {
      var m = drawer.querySelector('.qb-added');
      if (m) m.classList.remove('is-visible');
    }, 5000);
  }
  function watch(cn) {
    if (cn._qbAddedWatched) return;
    var drawer = cn.closest && cn.closest('quick-buy-drawer');
    if (!drawer) return;
    cn._qbAddedWatched = true;
    new MutationObserver(function () {
      if (!cn.hasAttribute('hidden') && (cn.textContent || '').trim().length > 0) showAdded(drawer);
    }).observe(cn, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true });
  }
  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches('cart-notification') && node.closest('quick-buy-drawer')) watch(node);
    if (node.querySelectorAll) node.querySelectorAll('quick-buy-drawer cart-notification').forEach(watch);
  }
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) scan(added[j]);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.querySelectorAll('quick-buy-drawer cart-notification').forEach(watch);
})();

/* ===== PlayGoSports — theme the MOBILE Consentmo CMP cookie banner (desktop untouched) ===== */
(function(){
  if (window.__pgsCmpInit) return; window.__pgsCmpInit = true;
  var MQ = '(max-width: 767px)';
  function isMobile(){ return window.matchMedia(MQ).matches; }
  function styleBanner(){
    var host = document.querySelector('csm-cookie-consent');
    if(!host || !host.shadowRoot) return;
    var sr = host.shadowRoot;
    if(!sr.getElementById('pgs-cmp-style')){
      var st = document.createElement('style'); st.id = 'pgs-cmp-style';
      st.textContent = '@media '+MQ+'{'
        + '.csm-native-main-wrapper{font-family:var(--text-font-family,"Rubik",sans-serif) !important;}'
        + '.csm-native-main-wrapper *{font-family:inherit !important;}'
        + '.csm-native-title,[class*="csm-native-title"]{font-family:var(--heading-font-family,"Rubik",sans-serif) !important;text-transform:uppercase !important;letter-spacing:.01em !important;}'
        + '.csm-cookie-button{text-transform:uppercase !important;letter-spacing:.5px !important;font-weight:600 !important;}'
        + '.csm-accept-button,.csm-reject-button{background:#111 !important;color:#fff !important;border:0 !important;}'
        + '.csm-preferences-button{background:#fff !important;color:#111 !important;border:1px solid #111 !important;}'
        + '.csm-provider-group{border-radius:0 !important;}'
        + '.csm-native-readmore-button,.csm-native-main-wrapper a{color:#111 !important;text-decoration:underline !important;text-underline-offset:2px !important;}'
        + '}';
      sr.appendChild(st);
    }
    /* Floating widget stack (9/28): the "change consent" reopen shield is the bottom item of the bottom-right
       column (Consentmo -> Gorgias -> sticky ATC). Match the others: 60px circle (50px on <=767px), 20px from
       the corner. The wrapper carries inline right/bottom, hence !important. See custom.css for the Gorgias half. */
    if(!sr.getElementById('pgs-widget-stack-style')){
      var ws = document.createElement('style'); ws.id = 'pgs-widget-stack-style';
      ws.textContent = '#csm-wrapper > div:has(> #reopen_widget){right:20px !important;bottom:20px !important;}'
        + '#reopen_widget,#reopen_widget svg{width:60px !important;height:60px !important;}'
        /* Hidden while the mini cart is open; the vars are set from custom.css (html:has(#mini-cart[open])). */
        + '#csm-wrapper > div:has(> #reopen_widget){visibility:var(--pgs-csm-reopen-vis,visible) !important;transition:visibility 0s linear var(--pgs-csm-reopen-delay,.6s) !important;}'
        + '@media '+MQ+'{#reopen_widget,#reopen_widget svg{width:50px !important;height:50px !important;}}';
      sr.appendChild(ws);
    }
    var mob = isMobile();
    sr.querySelectorAll('.csm-native-main-wrapper, .csm-cookie-button').forEach(function(el){
      if(mob) el.style.setProperty('border-radius','0','important');
      else el.style.removeProperty('border-radius');
    });
  }
  function watch(){
    var host = document.querySelector('csm-cookie-consent');
    if(host && host.shadowRoot && !host.__pgsObs){
      host.__pgsObs = new MutationObserver(function(){ styleBanner(); });
      host.__pgsObs.observe(host.shadowRoot, {childList:true, subtree:true});
    }
    styleBanner();
  }
  if(document.querySelector('csm-cookie-consent')) watch();
  var n=0, iv=setInterval(function(){ var h=document.querySelector('csm-cookie-consent'); if(h && h.shadowRoot){ watch(); clearInterval(iv); } if(++n>60) clearInterval(iv); }, 300);
  window.addEventListener('resize', styleBanner);
})();


/* PGS PLP: on ANY swatch toggle (color / design / size / pack), swap card image + price + link + Add-to-Cart variant (2026-09-25; was size-only 2026-09-17) */
(function(){
  document.addEventListener('change', function(e){
    var radio = e.target;
    if(!radio || !radio.classList || !radio.classList.contains('color-swatch__radio')) return;
    var card = radio.closest('product-item');
    if(!card) return;
    var priceMoney = radio.getAttribute('data-variant-price');
    var compareMoney = radio.getAttribute('data-variant-compare');
    var vid = radio.getAttribute('data-variant-id');
    var url = radio.getAttribute('data-variant-url');
    var priceList = card.querySelector('.product-item-meta__price-list-container .price-list');
    if(priceList && priceMoney){
      if(compareMoney){
        priceList.innerHTML =
          '<span class="price price--highlight"><span class="visually-hidden">Regular price</span>'+priceMoney+'</span>'+
          '<span class="price price--compare"><span class="visually-hidden">Sale price</span>'+compareMoney+'</span>';
      } else {
        priceList.innerHTML = '<span class="price"><span class="visually-hidden">Regular price</span>'+priceMoney+'</span>';
      }
    }
    var idInput = card.querySelector('form input[name="id"]');
    if(idInput && vid) idInput.value = vid;
    if(url){ card.querySelectorAll('a.product-item__aspect-ratio[href], a.product-item-meta__reviews-badge[href]').forEach(function(a){ a.setAttribute('href', url); }); }
    var mediaId = radio.getAttribute('data-variant-featured-media');
    if(mediaId){
      card.querySelectorAll('.product-item__image-wrapper img[data-media-id]').forEach(function(img){
        img.hidden = (String(img.getAttribute('data-media-id')) !== String(mediaId));
      });
    }
  });
})();

/* -----------------------------------------------------------------------------
 * Re-hydrate Yotpo widgets after Focal's variant re-render (PDP).
 *
 * Focal's <product-rerender> swaps the product-info HTML (including the Yotpo
 * star-rating widget instance) on every variant change. Yotpo injects its widgets
 * once on load and does NOT re-scan the fresh markup, so selecting a 2nd variant
 * leaves the stars blank until a full page reload. Fix: on Focal's variant-change
 * event AND whenever a fresh .yotpo-widget-instance is swapped in, re-run Yotpo's
 * widget init. initWidgets() is idempotent (skips already-initialised widgets), so
 * the debounced repeat calls are safe and don't disturb the reviews widget below.
 * --------------------------------------------------------------------------- */
(function () {
  if (!/\/products\//.test(window.location.pathname)) return;

  var t;
  function reinit() {
    try {
      if (window.yotpoWidgetsContainer && window.yotpoWidgetsContainer.initWidgets) {
        window.yotpoWidgetsContainer.initWidgets();
      } else if (window.yotpo && window.yotpo.refreshWidgets) {
        window.yotpo.refreshWidgets();
      }
    } catch (e) {}
  }
  function schedule() { clearTimeout(t); t = setTimeout(reinit, 350); }

  function start() {
    var info = document.querySelector('.product__info') || document.body;

    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if ((n.classList && n.classList.contains('yotpo-widget-instance')) ||
                (n.querySelector && n.querySelector('.yotpo-widget-instance'))) {
              schedule();
              return;
            }
          }
        }
      }).observe(info, { childList: true, subtree: true });
    }

    // Focal dispatches these on the product form when the variant changes.
    document.addEventListener('variant:change', schedule, true);
    document.addEventListener('variant:changed', schedule, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* -----------------------------------------------------------------------------
 * Fix Yotpo review submission: inject the product_title/url/image the widget omits.
 *
 * Yotpo's review form (review_source=widget_v3) POSTs to
 * api-cdn.yotpo.com/v1/widget/reviews with product_title EMPTY, so Yotpo rejects
 * EVERY review with 400 "Missing product_title". The review already maps to the
 * product by sku; only the title/url/image metadata is missing. Fill them from the
 * page's product meta so submissions succeed. Touches ONLY that endpoint, ONLY when
 * product_title is blank; every other request passes through untouched.
 * --------------------------------------------------------------------------- */
(function () {
  if (!window.fetch) return;
  function meta(p) { var el = document.querySelector('meta[property="' + p + '"]'); return el ? (el.getAttribute('content') || '') : ''; }
  function fill(s) {
    var title = (meta('og:title') || (document.querySelector('.product-meta__title, .product__title, h1') || {}).textContent || '').trim();
    if (!title) return s; // no product context (not a PDP) -> leave untouched
    var url = location.origin + location.pathname;
    var img = meta('og:image');
    return s
      .replace(/product_title=(?=&|$)/,     'product_title='     + encodeURIComponent(title))
      .replace(/product_url=(?=&|$)/,       'product_url='       + encodeURIComponent(url))
      .replace(/product_image_url=(?=&|$)/, 'product_image_url=' + encodeURIComponent(img));
  }
  var orig = window.fetch;
  window.fetch = function (url, opts) {
    try {
      if (opts && opts.body != null && /\/v1\/widget\/reviews/i.test(String(url))) {
        var s = (typeof opts.body === 'string') ? opts.body
              : (opts.body instanceof URLSearchParams) ? opts.body.toString()
              : null;
        if (s !== null && /product_title=(?=&|$)/.test(s)) { opts.body = fill(s); }
      }
    } catch (e) {}
    return orig.call(this, url, opts);
  };
})();

/* -----------------------------------------------------------------------------
 * Buy-area star rating -> scroll to the reviews section.
 *
 * Yotpo's buy-area star widget ("N Reviews" / "Write the first review") is meant to
 * scroll down to the reviews on click, but does nothing on this theme. Wire it up:
 * click anywhere on the buy-area rating -> smooth-scroll to the PGS reviews section
 * (fallback: Yotpo's main reviews widget), offset for the sticky brand bar + header.
 * --------------------------------------------------------------------------- */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  var st = document.createElement('style');
  st.textContent = '.product__info .product-meta__rating{cursor:pointer}';
  (document.head || document.documentElement).appendChild(st);

  function target() {
    return document.querySelector('.shopify-section--pgs-prodrev')
        || document.querySelector('.yotpo-widget-instance[data-yotpo-instance-id="860923"]')
        || document.querySelector('.yotpo-reviews-main-widget');
  }
  function stickyOffset() {
    var o = 0;
    ['.shopify-section--brand-bar', '.shopify-section--header'].forEach(function (s) {
      var el = document.querySelector(s);
      if (el && getComputedStyle(el).position === 'sticky') o += el.getBoundingClientRect().height;
    });
    return o + 16;
  }
  document.addEventListener('click', function (e) {
    var hit = e.target.closest && e.target.closest('.product__info .product-meta__rating');
    if (!hit) return;
    var t = target();
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var y = t.getBoundingClientRect().top + window.scrollY - stickyOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: 'auto' });
  }, true);
})();

/* ---------------------------------------------------------------------------
 * Contact form (Globo Form Builder): when the "Please select a topic" dropdown
 * (custom class please-select-root) changes, clear the answers in the
 * continue-root checkbox and the question-answer-root radios, so a previous
 * topic's "Continue" / "Did this answer your question?" choice doesn't carry
 * over. A change event is fired on each cleared input so Globo's conditional
 * logic re-hides the fields that depended on it. 2026-09-30
 * --------------------------------------------------------------------------- */
(function () {
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('.please-select-root select')) return;
    var form = e.target.closest('form') || document;
    form.querySelectorAll('.continue-root input, .question-answer-root input').forEach(function (input) {
      if (!input.checked) return;
      input.checked = false;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();

/* ---------------------------------------------------------------------------
 * Contact form: when "Did this answer your question?" (question-answer-root)
 * is answered with the first option ("Yes, that resolved it"), swap the grey
 * note box for a centered "Glad that helped." with an "Actually, I still need
 * to reach out" link. The link picks the last option ("No, I still need help")
 * so Globo's conditional logic reveals the rest of the form as usual.
 * The swap is a class on the form (pgs-qa-resolved); CSS in custom.css hides
 * the note, the question and Submit while it's set. Changing the topic clears
 * the radios (block above), which fires change and drops the class. 2026-09-30
 * --------------------------------------------------------------------------- */
(function () {
  function thanksFor(root) {
    var el = root.querySelector('.pgs-qa-thanks');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'pgs-qa-thanks';
    el.innerHTML = '<p class="pgs-qa-thanks__text" role="status">Glad that helped.</p>'
      + '<button type="button" class="pgs-qa-thanks__link">Actually, I still need to reach out</button>';
    el.querySelector('button').addEventListener('click', function () {
      var radios = root.querySelectorAll('input[type="radio"]');
      var no = radios[radios.length - 1];
      if (!no) return;
      no.checked = true;
      no.dispatchEvent(new Event('change', { bubbles: true }));
      no.focus();
    });
    root.appendChild(el);
    return el;
  }
  document.addEventListener('change', function (e) {
    var root = e.target.closest && e.target.closest('.question-answer-root');
    if (!root || e.target.type !== 'radio') return;
    var form = root.closest('form');
    if (!form) return;
    var yes = root.querySelector('input[type="radio"]');
    var resolved = !!(yes && yes.checked);
    if (resolved) thanksFor(root);
    form.classList.toggle('pgs-qa-resolved', resolved);
  });
})();

/* ---------------------------------------------------------------------------
 * Contact form: while the "Continue" checkbox (continue-root) or the "Did
 * this answer your question?" radios (question-answer-root) are showing, the
 * form can't be submitted until "Continue" is checked / the last option
 * ("No, I still need help") is picked. Submit is hidden in the meantime
 * (form.pgs-qa-blocked, CSS in custom.css), and clicks / Enter-key submits
 * are stopped in the capture phase before Globo's handlers see them, with
 * focus moved to the option they need to pick. 2026-10-01
 * --------------------------------------------------------------------------- */
(function () {
  function shown(el) {
    return el.getClientRects().length > 0;
  }
  /* The input the visitor still has to pick, or null if the form can submit */
  function pending(form) {
    var cont = form.querySelector('.continue-root');
    if (cont && shown(cont)) {
      var box = cont.querySelector('input[type="checkbox"]');
      if (box && !box.checked) return box;
    }
    var qa = form.querySelector('.question-answer-root');
    if (qa && shown(qa)) {
      var radios = qa.querySelectorAll('input[type="radio"]');
      var no = radios[radios.length - 1];
      if (no && !no.checked) return no;
    }
    return null;
  }
  function sync(form) {
    form.classList.toggle('pgs-qa-blocked', !!pending(form));
  }
  function guard(e, form) {
    if (!form || !form.querySelector('.continue-root, .question-answer-root')) return;
    var input = pending(form);
    sync(form);
    if (!input) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    input.focus();
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.wizard__submit');
    if (btn) guard(e, btn.closest('form'));
  }, true);
  document.addEventListener('submit', function (e) {
    guard(e, e.target);
  }, true);
  /* Globo shows/hides conditional fields in its own change handler, so check
     again once it has run */
  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('form');
    if (!form || !form.querySelector('.continue-root, .question-answer-root')) return;
    setTimeout(function () { sync(form); }, 0);
  });
})();

/* ---------------------------------------------------------------------------
 * Contact form: the Attachments upload (data-type file2) doubles as "Photos of
 * the issue" when the topic is Damage / defect or Warranty and "No, I still
 * need help" is picked. It's relabelled, gets a description, and is made
 * required by adding Globo's presence attribute - Globo reads that on every
 * validate, so its own field error and error summary cover it (the message
 * uses the label's data-label). Any other topic gets the original label and
 * required state back. Submissions still name the field Attachments, since
 * that comes from the app. 2026-10-26
 * --------------------------------------------------------------------------- */
(function () {
  var TOPICS = ['Damage / defect', 'Warranty'];
  var LABEL = 'Photos of the issue';
  var DESC = 'A photo of the issue, and the box label if you still have it';

  function wantsPhotos(form) {
    var topic = form.querySelector('.please-select-root select');
    if (!topic || TOPICS.indexOf(topic.value) === -1) return false;
    var radios = form.querySelectorAll('.question-answer-root input[type="radio"]');
    var no = radios[radios.length - 1];
    return !!(no && no.checked);
  }
  function sync(form) {
    var ctrl = form.querySelector('.globo-form-control[data-type="file2"]');
    var input = ctrl && ctrl.querySelector('input[data-type="file2"]');
    var label = ctrl && ctrl.querySelector('label');
    var text = label && label.querySelector('.label-content');
    if (!input || !text) return;
    var btn = ctrl.querySelector('.gfb__dropzone--placeholder--button');
    /* Remember what the app gave us the first time through */
    if (!ctrl.hasAttribute('data-pgs-label')) {
      ctrl.setAttribute('data-pgs-label', label.getAttribute('data-label') || text.textContent.trim());
      ctrl.setAttribute('data-pgs-required', input.hasAttribute('presence') ? '1' : '');
      if (btn) ctrl.setAttribute('data-pgs-describedby', btn.getAttribute('aria-describedby') || '');
    }
    var on = wantsPhotos(form);
    if (on === ctrl.classList.contains('pgs-photos')) return;
    ctrl.classList.toggle('pgs-photos', on);

    var name = on ? LABEL : ctrl.getAttribute('data-pgs-label');
    text.textContent = name;
    text.setAttribute('data-label', name);
    label.setAttribute('data-label', name);

    var descId = input.id + '-pgs-desc';
    var desc = document.getElementById(descId);
    var star = label.querySelector('.pgs-photos__req');
    if (on) {
      if (!star) {
        star = document.createElement('span');
        star.className = 'text-danger text-smaller pgs-photos__req';
        star.innerHTML = '<span aria-hidden="true"> *</span><span class="visually-hidden"> (required)</span>';
        text.insertAdjacentElement('afterend', star);
      }
      if (!desc) {
        desc = document.createElement('p');
        desc.id = descId;
        desc.className = 'pgs-photos__desc';
        desc.textContent = DESC;
        label.insertAdjacentElement('afterend', desc);
      }
      if (btn) btn.setAttribute('aria-describedby', (descId + ' ' + ctrl.getAttribute('data-pgs-describedby')).trim());
      input.setAttribute('presence', '');
    } else {
      if (star) star.remove();
      if (desc) desc.remove();
      if (btn) btn.setAttribute('aria-describedby', ctrl.getAttribute('data-pgs-describedby'));
      if (!ctrl.getAttribute('data-pgs-required')) {
        input.removeAttribute('presence');
        /* Drop a "required" error left over from the photo version */
        ctrl.classList.remove('has-error');
        input.removeAttribute('aria-invalid');
        ctrl.querySelectorAll('.help-block.error').forEach(function (p) { p.remove(); });
      }
    }
  }
  /* Globo shows/hides conditional fields in its own change handler, so sync
     once it has run */
  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('form');
    if (!form || !form.querySelector('.question-answer-root')) return;
    setTimeout(function () { sync(form); }, 0);
  });
})();

/* -----------------------------------------------------------------------------
 * Product card stars after sorting / paging. Collection and search pages reload
 * their product grid in place (#facet-main) when the shopper sorts or changes
 * page, and Yotpo only fills its .yotpo.bottomLine star blocks on page load, so
 * every card lost its stars until a full reload. Ask Yotpo to fill the new ones.
 * --------------------------------------------------------------------------- */
(function () {
  var main = document.getElementById('facet-main');
  if (!main || !window.MutationObserver) return;
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      if (!main.querySelector('.yotpo.bottomLine:empty')) return;
      if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') window.yotpo.refreshWidgets();
    });
  }).observe(main, { childList: true });
})();
